import { ApplicationState } from 'application/redux';
import { connect } from 'react-redux';
import ProvisionedDevicesComponent from './provisioned-devices-component';
import { changePageProvDevices, fetchProvisionedDevices, onDelete } from './redux/actions';

const mapStateToProps = (state: ApplicationState) => ({
  provisionedDevices: state.devices.detail.provisionedDevices,
  t: state.i18n.t,
  pagination: state.pagination,
  offset: state.application.offset
});

export default connect(mapStateToProps, {
  fetchProvisionedDevices,
  onDelete,
  changePageProvDevices,
})(ProvisionedDevicesComponent);
